(function ($, Drupal, once, cookies) {
  'use strict';

  Drupal.behaviors.onboarding = {
    attach: function (context, settings) {

      $(once('skip-onboarding', '.block-onboarding', context)).each(function () {
        // Show/hide introduction block on main dashboard according to user preference saved in cookie.
        $('.block-onboarding').each((index, el) => {
          if (cookies.get('skip-onboarding')) {
            $('.panel', el).removeClass('show');
            $('.accordion.yellow', el).removeClass('up');
          }
        });

        // Blocks onboarding.
        setTimeout(() => {
          $(once('initialize-accordion', '.js-onboarding-skip', context)).each(function () {
            $(this).on('click', function () {
              const $this = $('.block-onboarding .accordion');
              toggleAccordion($this);
            });
          }, 1000);

          // Blocks accordion.
          setTimeout(() => {
            $('.accordion').click((e) => {
              const $this = $(e.currentTarget);
              toggleAccordion($this);
            });
          }, 1000);

          function toggleAccordion($this) {
            $this.toggleClass('up');
            $this.siblings('.panel').toggleClass('show');
            // Save user preference in cookie to remember if the introduction block should be shown.
            if ($this.hasClass('yellow')) {
              if ($this.siblings('.panel').hasClass('show')) {
                cookies.remove('skip-onboarding');
              } else {
                cookies.set('skip-onboarding', 1, {expires: 28, path: '/'})
              }
            }
          }
        })
      });
    }
  }
})(jQuery, Drupal, once, window.Cookies);

